import { api } from "../config";

/**
 * Call backend to generate AI explanation for a feedback.
 * SUPER_ADMIN only endpoint.
 */
export const explainFeedback = async (feedbackId, { forceRefresh = false } = {}) => {
    const response = await api.post(
        `/product-feedback/${feedbackId}/explain`,
        null,
        {
            params: { force_refresh: forceRefresh },
            timeout: 45000, // 45s timeout (Bedrock can take time)
        }
    );
    return response.data;
};

